module.exports = __webpack_public_path__ + "static/media/profile-address-book-red.6d7ae321.svg";